import { render, staticRenderFns } from "./EditCandidatura.vue?vue&type=template&id=3fb7a7fe"
import script from "./EditCandidatura.vue?vue&type=script&lang=js"
export * from "./EditCandidatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports